import { render, staticRenderFns } from "./OdontogramPreviewTooth.vue?vue&type=template&id=38aa40a0"
import script from "./OdontogramPreviewTooth.vue?vue&type=script&lang=js"
export * from "./OdontogramPreviewTooth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports